import { render, staticRenderFns } from "./PortalLoginPage.vue?vue&type=template&id=4c14ae22&scoped=true&"
import script from "./PortalLoginPage.vue?vue&type=script&lang=js&"
export * from "./PortalLoginPage.vue?vue&type=script&lang=js&"
import style0 from "./PortalLoginPage.vue?vue&type=style&index=0&id=4c14ae22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c14ae22",
  null
  
)

export default component.exports